import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { LINEAR_GRADIENT_BG } from '../../../constants';
import _ from 'lodash';

export function AlertDismissSable() {
    const [show, setShow] = useState(true);

    const handleDismiss = () => {
        setShow(false);
    };

    const handleShow = () => {
        setShow(true);
    };

    return (
        <div>
            {show ? (
                <Alert variant="danger" onClose={handleDismiss} dismissible>
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>
                        Change this and that and try again. Duis mollis, est non commodo
                        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                        Cras mattis consectetur purus sit amet fermentum.
                    </p>
                    <p>
                        <Button variant="danger">Take this action</Button>
                        <span> or </span>
                        <Button variant="outline-secondary" onClick={handleDismiss}>
                            Hide Alert
                        </Button>
                    </p>
                </Alert>
            ) : (
                <Button variant="primary" onClick={handleShow}>
                    Show Alert
                </Button>
            )}
        </div>
    );
};

export function PopupModal(props) {
    const [balanceOrderGroup, { loading: loading }] = useMutation(props.apiPath);
    const handleAPI = async () => {
        try {
            await _balanceOrderGroup({ api: props?.apiPath, filter: props?.filter });
            props.onCancel();
        } catch (error) {
            console.log("props handle api error: ", error);
        }
    };
    const _balanceOrderGroup = async ({ api, filter }) => {
        try {
            if (loading) return;
            // props.onHide();

            await balanceOrderGroup({
                variables: {
                    where: filter,
                },
            });

        } catch (error) {
            console.log("send order group claim balance error: ", error);
        }
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header
                // closeButton
                className={props.bgColor || 'bg-danger text-white'}
            >
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title || "Modal heading"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={props.bgColor || 'bg-danger text-white'}>
                <h5>{props.centered || "Centered Modal"}</h5>
                <p>
                    {props.content ||
                        `Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
                        dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
                        consectetur ac, vestibulum at eros.`}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={loading} variant='light' onClick={props.onCancel}>ຍົກເລີກ</Button>
                <Button style={{ background: LINEAR_GRADIENT_BG, border: 'none' }} onClick={handleAPI}>
                    {loading ? <Spinner /> : 'ຕົກລົງ'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
